<template>
    <div>
      <el-tabs v-model="tabsKey" @tab-click="handleClick" type="card">
          <el-tab-pane name="search" label="查詢"  >
              <Search @addTabs="addTabs" @detailTabs="detailTabs" />            
          </el-tab-pane>
          <el-tab-pane name="add" label="增加" v-if="isSohowAdd">
              <Add @back="back" />
          </el-tab-pane>
          <el-tab-pane name="edit" label="編輯" v-if="isShowEdit">
              <Edit :couponKey="couponKey" @back="back" />
          </el-tab-pane>
          <el-tab-pane name="detail" label="詳細" v-if="isShowDetail">
              <Detail :couponKey="couponKey" @editTabs="editTabs" @back="back" />
          </el-tab-pane>
      </el-tabs>
      
    </div>
</template>

<script>
import Search from './Coupon/Search'
import Add from './Coupon/Add'
import Edit from './Coupon/Edit'
import Detail from './Coupon/Detail'
    export default {
        name: 'Coupon',
        components:{
            Search,
            Edit,
            Add, 
            Detail
        },
        data() {
            return {
                isSohowAdd: false,
                isShowDetail: false,
                isShowEdit: false,
                tabsKey: 'search',
                couponKey: ''
            }
        },
        methods: {
            addTabs(){
                this.tabsKey = 'add'
                this.isSohowAdd = true
            },
            editTabs(couponKey){
                this.couponKey = couponKey
                this.tabsKey = 'edit'
                this.isShowEdit = true
                this.isShowDetail = false
            },
            detailTabs(couponKey){
                this.couponKey = couponKey 
                this.tabsKey = 'detail'
                this.isShowDetail = true
                
            },
            handleClick(tab, event){
                if (tab.name == 'search') {
                    this.isSohowAdd = false
                    this.isShowDetail = false
                    this.isShowEdit = false
                }
            },
            back(){
            this.tabsKey = 'search'
            this.isSohowAdd = false
            this.isShowDetail = false
            this.isShowEdit = false
            }
            
        },
    }
</script>

<style lang="scss" scoped>
    
</style>